/**
 * Form validation rules for use in Vue components and tests
 */

export const formValidationRules = {
  required: value => {
    if (Array.isArray(value) && value.length == 0) return "Required";
    return !!value || "Required";
  },
  
  multipleChoiceRequired: value => {
    if (!Array.isArray(value) || value.length === 0) return "Please select at least one option";
    return true;
  },
};
